@if (currentModel()) {
  <div id="topnav" class="sticky-top">
    <div class="container topnavwrap">
      <div class="row">
        <div class="col-lg-4 col-md-2 col-4 d-flex align-items-center">
          <a href="javascript:void(0)" (click)="onLogoPressed()" anchorExternalUrl [style.height]="logoAnchorHeight()">
            <img
              #logoSmall
              [class.sps--abv]="isSmallLogoVisible()"
              [class.sps--blw]="!isSmallLogoVisible()"
              class="sps mh-100 w-100"
              alt="Logo DUO"
              [src]="currentModel().logoSmallUrl" />
          </a>
        </div>

        <div class="col-lg-8 col-md-10 col-8 d-flex align-items-center justify-content-end">
          <ul class="nav nav-pills">
            <!-- GAPTER-555 show if more than 2 options -->
            @if (
              currentModel().languageModels.length > 2 &&
              style().languageDropdownVisible &&
              currentModel().languageModels?.length &&
              getCurrentLanguageCode()
            ) {
              <li class="menu-language nav-item dropdown">
                <a
                  id="language-dropdown"
                  href="javascript:void(0)"
                  class="nav-link dropdown-toggle"
                  data-bs-toggle="dropdown"
                  data-bs-display="static"
                  role="button"
                  aria-haspopup="true"
                  aria-expanded="false">
                  <i class="fal fa-globe"></i>&nbsp;<span class="d-none d-sm-none d-md-inline">{{
                    getCurrentLanguageCode()
                  }}</span>
                </a>

                <div class="dropdown-menu dropdown-menu-end dropdown-menu-md-start">
                  @for (language of currentModel().languageModels; track $index) {
                    <li role="menuitem" style="cursor: pointer">
                      <a
                        (keyup.enter)="onLanguageChanged(language.code)"
                        (click)="onLanguageChanged(language.code)"
                        class="dropdown-item"
                        tabindex="">
                        {{
                          isValidTranslation("GAST-COMMON-NG.LANGUAGE." + language.code.toUpperCase())
                            ? ("GAST-COMMON-NG.LANGUAGE." + language.code | uppercase | translate)
                            : language.visibleText
                        }}
                      </a>
                    </li>
                  }
                </div>
              </li>
            }

            <!-- GAPTER-555 show if 2 or less options -->
            @if (
              currentModel().languageModels.length < 3 &&
              style().languageDropdownVisible &&
              currentModel().languageModels &&
              getCurrentLanguageCode()
            ) {
              <li class="menu-language nav-item nav-link">
                <i class="fal fa-globe"></i>&nbsp;

                @for (language of currentModel().languageModels; track $index) {
                  <a
                    [tabIndex]="0"
                    (keyup.enter)="onLanguageChanged(language.code)"
                    (click)="onLanguageChanged(language.code)"
                    href="javascript:void(0);"
                    style="cursor: pointer"
                    [class.active]="getCurrentLanguageCode().toUpperCase() === language.code.toUpperCase()"
                    [class.divider-border]="$index === 0 && currentModel().languageModels.length === 2">
                    <span>{{ language.code.toUpperCase() }}&nbsp;</span>
                  </a>
                }
              </li>
            }

            @for (navTabUrl of currentModel().navigationTabUrls; track $index) {
              <li class="nav-item d-none d-sm-none d-md-inline">
                @if (navTabUrl.linkUrl) {
                  <a [href]="navTabUrl.linkUrl" class="nav-link" anchorExternalUrl>
                    <ng-container *ngTemplateOutlet="linkContent"></ng-container>
                  </a>
                } @else {
                  <a [routerLink]="navTabUrl.routerLinkUrl" class="nav-link" anchorExternalUrl>
                    <ng-container *ngTemplateOutlet="linkContent"></ng-container>
                  </a>
                }
                <ng-template #linkContent>
                  <i [class]="navTabUrl.iconClass"></i
                  ><span class="d-none d-sm-none d-md-inline">
                    {{ navTabUrl.useTranslation ? (navTabUrl.displayText | translate) : navTabUrl.displayText }}
                  </span>
                </ng-template>
              </li>
            }

            @if (style().loginDropdownVisible) {
              <li class="nav-item dropdown">
                <a
                  id="login"
                  href="javascript:void(0)"
                  class="nav-link dropdown-toggle"
                  data-bs-toggle="dropdown"
                  data-bs-display="static"
                  role="button"
                  aria-haspopup="true"
                  aria-expanded="false">
                  <i [class]="isAuthorized() ? 'fas fa-user-circle' : 'fal fa-user'"></i>&nbsp;<span
                    [class]="isAuthorized() ? 'd-inline d-md-inline' : 'd-none d-sm-none d-md-inline'"
                    >{{ isAuthorized() ? user()?.username : "Login" }}</span
                  >
                </a>
                <div class="dropdown-menu dropdown-menu-end">
                  @if (!isAuthorized()) {
                    <div class="loginmenu_login" id="loginmenulogin">
                      <a class="btn btn-primary" href="javascript:void(0)" (click)="login()">Login</a>
                      <div class="dropdown-divider"></div>
                    </div>
                  }

                  <ng-content select="[login-buttons]"></ng-content>

                  @for (loginDropdownUrl of currentModel().loginDropdownUrls; track $index) {
                    @if (loginDropdownUrl.routerLinkUrl) {
                      <a class="dropdown-item" [routerLink]="loginDropdownUrl.routerLinkUrl">
                        {{
                          loginDropdownUrl.useTranslation ? (loginDropdownUrl.text | translate) : loginDropdownUrl.text
                        }}
                      </a>
                    } @else {
                      <a class="dropdown-item" [href]="loginDropdownUrl.linkUrl" anchorExternalUrl>
                        {{
                          loginDropdownUrl.useTranslation ? (loginDropdownUrl.text | translate) : loginDropdownUrl.text
                        }}
                      </a>
                    }
                  }

                  @if (currentModel().loginDropdownUrls && currentModel().loginDropdownUrls.length > 0) {
                    <div class="dropdown-divider"></div>
                  }
                  <img
                    class="img-fluid gastlogo mx-auto d-block"
                    alt="g.a.s.t."
                    src="portal-assets/img/gast.svg"
                    width="90"
                    height="29" />

                  @for (productUrl of currentModel().loginDropdownProductUrls; track $index) {
                    <a class="dropdown-item" target="_blank" [href]="productUrl.linkUrl" anchorExternalUrl>
                      {{ productUrl.useTranslation ? (productUrl.text | translate) : productUrl.text }}
                    </a>
                  }

                  @if (isAuthorized()) {
                    <div id="loginmenulogout">
                      <div class="dropdown-divider"></div>
                      <a class="dropdown-item" href="javascript:void(0)" (click)="logout()" id="logoutLink">Logout</a>
                    </div>
                  }
                </div>
              </li>
            }
          </ul>
        </div>
      </div>
    </div>
  </div>
}

<div class="container headerwrap">
  <div class="row">
    @if (currentModel().logoGastBigUrl) {
      <div class="col-sm-6 logo-gast-big">
        <a href="javascript:void(0)" (click)="onLogoPressed()" class="duo-logo">
          <img
            class="img-fluid"
            [src]="currentModel()?.logoGastBigUrl"
            [alt]="'GAST-PORTAL-NG.HEADER-COMPONENT.GAST_IMAGE_BIG' | translate"
            width="350"
            height="72" />
        </a>
      </div>
    }
    <div class="col-sm-6" [ngClass]="{ 'logo-big': !!currentModel().logoGastBigUrl }">
      <a href="javascript:void(0)" (click)="onLogoPressed()" class="duo-logo">
        <img
          class="img-fluid"
          [src]="currentModel().logoBigUrl"
          [alt]="'GAST-PORTAL-NG.HEADER-COMPONENT.LOGO' | translate"
          width="276"
          height="72" />
      </a>
    </div>
  </div>
</div>
